/** Context provider for the global search bar state. */
import { useState, useCallback } from 'react';
import { GoBarContext } from '@/features/search/GoBarContext.def';

export const GoBarProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const openGoBar = useCallback(() => setIsOpen(true), []);
  const closeGoBar = useCallback(() => setIsOpen(false), []);

  return (
    <GoBarContext.Provider value={{ isOpen, openGoBar, closeGoBar }}>
      {children}
    </GoBarContext.Provider>
  );
};
